export default __webpack_public_path__ + "static/media/Ashoka_Particle_Flame_5.f43c99a3.png";